import client from "./client";
import { buildAuthAndGuestHeaders } from "./cartHeaders";

export async function getCart(accessToken) {
  const res = await client.get("/cart", { headers: buildAuthAndGuestHeaders(accessToken) });
  return res.data;
}

export async function addToCart(productId, optionId, qty, accessToken) {
  const res = await client.post(
    "/cart/items",
    { productId, optionId, qty },
    { headers: buildAuthAndGuestHeaders(accessToken) }
  );
  return res.data;
}

export async function updateCartItemQty(cartItemId, qty, accessToken) {
  const res = await client.put(
    `/cart/items/${cartItemId}`,
    { qty },
    { headers: buildAuthAndGuestHeaders(accessToken) }
  );
  return res.data;
}

export async function removeCartItem(cartItemId, accessToken) {
  const res = await client.delete(`/cart/items/${cartItemId}`, { headers: buildAuthAndGuestHeaders(accessToken) });
  return res.data;
}

export async function clearCart(accessToken) {
  const res = await client.delete("/cart", { headers: buildAuthAndGuestHeaders(accessToken) });
  return res.data;
}
